import { render, staticRenderFns } from "./ui-form.vue?vue&type=template&id=b24f7c82&scoped=true"
import script from "./ui-form.vue?vue&type=script&lang=js"
export * from "./ui-form.vue?vue&type=script&lang=js"
import style1 from "./ui-form.vue?vue&type=style&index=1&id=b24f7c82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24f7c82",
  null
  
)

export default component.exports